import { Outlet } from "react-router-dom";
import { NotificationsContainer } from "../common/components/Notification/Notification";
import { useFeatureFlagVariantKey } from "posthog-js/react";
import { useEffect } from "react";
import { useExperimentFlags } from "../buyerStateDefs";
import { PageViewTracker } from "./PageViewTracker";
import CookieConsent from "./CookieConsent";
import { GlobalHelpAndRfq } from "./GlobalHelpAndRfq";

export const RootContainer = () => {
  const searchEngineVariant = useFeatureFlagVariantKey(
    "search-engine-experiment",
  );
  const setDummySearchExperimentVariant = useExperimentFlags(
    (state) => state.setDummySearchExperimentVariant,
  );

  useEffect(() => {
    if (searchEngineVariant && setDummySearchExperimentVariant) {
      setDummySearchExperimentVariant(searchEngineVariant as string);
    }
  }, [searchEngineVariant, setDummySearchExperimentVariant]);

  return (
    <>
      <PageViewTracker />
      <NotificationsContainer />
      <Outlet />
      <GlobalHelpAndRfq />
      <CookieConsent />
    </>
  );
};
